import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getLanguagesAPI() {
  return serviceRequest(() => Service.supportedCountryControllerList());
}
